import {intlFormatDistance} from "date-fns";

import {buildRecentSearchFormValues, buildSearchUrl} from "../../search/utils/build_recent_filters_search_values";
import {getRecentFilterDisplayParts} from "../../search/utils/format_recent_filter_text";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

const RECENT_SEARCH_EMPTY_DESCRIPTION = "Nie wybrano dodatkowych filtrów";

export const mapRecentFiltersToPersonalized = (recentFilters: IRecentFilter[]): IPersonalizedRecentSearch[] =>
    recentFilters.flatMap((recentFilter, index) => {
        // Stored filters come from localStorage — a single malformed or legacy
        // entry must not take down the whole personalized homepage.
        try {
            const {location, rooms, area, price, filterParts} = getRecentFilterDisplayParts({
                filters: recentFilter.filters,
                search: recentFilter.search
            });

            return [
                {
                    id: `recent-search-${recentFilter.timestamp}-${index}`,
                    title: location || "Ostatnie wyszukiwanie",
                    description: filterParts.length > 0 ? filterParts.join(" · ") : RECENT_SEARCH_EMPTY_DESCRIPTION,
                    href: buildSearchUrl(buildRecentSearchFormValues(recentFilter)),
                    roomsLabel: rooms,
                    areaLabel: area,
                    priceLabel: price,
                    recencyLabel: intlFormatDistance(recentFilter.timestamp, Date.now(), {locale: "pl", numeric: "auto"}),
                    newOffersLabel: null,
                    source: "browser" as const
                }
            ];
        } catch {
            return [];
        }
    });
import {intlFormatDistance} from "date-fns";

import {buildRecentSearchFormValues, buildSearchUrl} from "../../search/utils/build_recent_filters_search_values";
import {getRecentFilterDisplayParts} from "../../search/utils/format_recent_filter_text";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedRecentSearch} from "../types/IPersonalizedHomepage";

const RECENT_SEARCH_EMPTY_DESCRIPTION = "Nie wybrano dodatkowych filtrów";

export const mapRecentFiltersToPersonalized = (recentFilters: IRecentFilter[]): IPersonalizedRecentSearch[] =>
    recentFilters.flatMap((recentFilter, index) => {
        // Stored filters come from localStorage — a single malformed or legacy
        // entry must not take down the whole personalized homepage.
        try {
            const {location, rooms, area, price, filterParts} = getRecentFilterDisplayParts({
                filters: recentFilter.filters,
                search: recentFilter.search
            });

            return [
                {
                    id: `recent-search-${recentFilter.timestamp}-${index}`,
                    title: location || "Ostatnie wyszukiwanie",
                    description: filterParts.length > 0 ? filterParts.join(" · ") : RECENT_SEARCH_EMPTY_DESCRIPTION,
                    href: buildSearchUrl(buildRecentSearchFormValues(recentFilter)),
                    roomsLabel: rooms,
                    areaLabel: area,
                    priceLabel: price,
                    recencyLabel: intlFormatDistance(recentFilter.timestamp, Date.now(), {locale: "pl", numeric: "auto"}),
                    newOffersLabel: null,
                    source: "browser" as const
                }
            ];
        } catch {
            return [];
        }
    });
